// modules/Multiplayer/MultiplayerRoomList.js
// 多人游戏房间列表模块

export default class MultiplayerRoomList {
    constructor(scene, ui) {
        this.scene = scene;
        this.ui = ui;
        this.rooms = [];
        this.roomListItems = [];
    }
    
    /**
     * 显示房间列表对话框
     */
    showRoomListDialog() {
        const container = this.ui.roomListContainer;
        if (!container) return;
        
        // 显示弹窗和遮罩
        if (container.overlay) container.overlay.setVisible(true);
        if (container.bg) container.bg.setVisible(true);
        if (container.title) container.title.setVisible(true);
        if (this.ui.refreshButton) this.ui.refreshButton.setVisible(true);
        if (this.ui.createRoomButton) this.ui.createRoomButton.setVisible(true);
    }
    
    /**
     * 隐藏房间列表对话框
     */
    hideRoomListDialog() {
        const container = this.ui.roomListContainer;
        if (!container) return;
        
        // 隐藏弹窗和遮罩
        if (container.overlay) container.overlay.setVisible(false);
        if (container.bg) container.bg.setVisible(false);
        if (container.title) container.title.setVisible(false);
        if (this.ui.refreshButton) this.ui.refreshButton.setVisible(false);
        if (this.ui.createRoomButton) this.ui.createRoomButton.setVisible(false);
    }
    
    /**
     * 更新房间列表
     * @param {Array} rooms - 房间列表
     * @param {Function} onJoinRoom - 加入房间回调 (roomId) => void
     */
    updateRoomList(rooms, onJoinRoom = null) {
        this.rooms = rooms;
        
        // 清除旧的房间列表项
        this.roomListItems.forEach(item => {
            if (item.bg) item.bg.destroy();
            if (item.nameText) item.nameText.destroy();
            if (item.infoText) item.infoText.destroy();
            if (item.joinButton) item.joinButton.destroy();
        });
        this.roomListItems = [];
        
        const container = this.ui.roomListContainer;
        if (!container) return;
        
        if (rooms.length === 0) {
            if (container.emptyText) {
                container.emptyText.setText('暂无房间，点击"创建房间"创建一个新房间');
                container.emptyText.setVisible(true);
            }
            return;
        }
        
        if (container.emptyText) {
            container.emptyText.setVisible(false);
        }
        
        const centerX = this.scene.cameras.main.centerX;
        const startY = container.listContentY + 20;
        const itemHeight = 60;
        const maxVisible = 6; // 最多显示6个房间
        const itemWidth = container.dialogWidth - 80;
        const itemX = centerX - itemWidth / 2;
        
        rooms.slice(0, maxVisible).forEach((room, index) => {
            const y = startY + index * itemHeight;
            
            // 房间项背景
            const itemBg = this.scene.add.graphics();
            itemBg.fillStyle(0x2a2a3e, 0.9);
            itemBg.fillRoundedRect(
                itemX,
                y - 25,
                itemWidth,
                itemHeight - 10,
                8
            );
            itemBg.lineStyle(2, 0x4cc9f0, 0.6);
            itemBg.strokeRoundedRect(
                itemX,
                y - 25,
                itemWidth,
                itemHeight - 10,
                8
            );
            itemBg.setDepth(7);
            
            // 房间名称
            const nameText = this.scene.add.text(
                itemX + 15,
                y - 10,
                room.name || room.id,
                {
                    fontSize: '18px',
                    fill: '#4cc9f0',
                    fontFamily: 'monospace',
                    fontWeight: 'bold'
                }
            );
            nameText.setOrigin(0, 0.5);
            nameText.setDepth(8);
            
            // 房间信息（玩家数、创建者等）
            const playerInfo = `${room.playerCount}/${room.maxPlayers} 玩家`;
            const createdBy = room.createdBy ? ` | 创建者: ${room.createdBy}` : '';
            const infoText = this.scene.add.text(
                itemX + 15,
                y + 10,
                playerInfo + createdBy,
                {
                    fontSize: '13px',
                    fill: '#aaaaaa',
                    fontFamily: 'monospace'
                }
            );
            infoText.setOrigin(0, 0.5);
            infoText.setDepth(8);
            
            // 加入按钮
            const joinButton = this.scene.add.text(
                itemX + itemWidth - 80,
                y,
                room.playerCount >= room.maxPlayers ? '已满' : '加入',
                {
                    fontSize: '16px',
                    fill: '#ffffff',
                    fontFamily: 'monospace',
                    backgroundColor: room.playerCount >= room.maxPlayers ? '#666666' : '#00aa00',
                    padding: { x: 25, y: 10 }
                }
            );
            joinButton.setOrigin(0.5);
            joinButton.setDepth(8);
            
            if (room.playerCount < room.maxPlayers && onJoinRoom) {
                joinButton.setInteractive({ useHandCursor: true });
                joinButton.on('pointerdown', () => {
                    this.hideRoomListDialog();
                    onJoinRoom(room.id);
                });
            }
            
            this.roomListItems.push({
                bg: itemBg,
                nameText: nameText,
                infoText: infoText,
                joinButton: joinButton,
                room: room
            });
        });
    }
    
    /**
     * 获取房间列表
     * @returns {Array} 房间列表
     */
    getRooms() {
        return this.rooms;
    }
    
    /**
     * 清理房间列表
     */
    destroy() {
        this.roomListItems.forEach(item => {
            if (item.bg) item.bg.destroy();
            if (item.nameText) item.nameText.destroy();
            if (item.infoText) item.infoText.destroy();
            if (item.joinButton) item.joinButton.destroy();
        });
        this.roomListItems = [];
        this.rooms = [];
    }
}

